import { Component, OnInit } from '@angular/core';
import { DESCIPTION_BASE, TITLE_TIMELINE } from 'src/app/constant/app-constant';
import { CanonicalService } from 'src/app/service/canonical/canonical.service';
import { MetaTagsService } from 'src/app/service/meta-tag/meta-tags.service';

@Component({
  selector: 'app-doc',
  templateUrl: './doc.component.html',
  styleUrls: ['./doc.component.scss']
})
export class DocComponent implements OnInit {

  constructor( private canonicalService: CanonicalService,private metaService: MetaTagsService) { }

  ngOnInit(): void {
    this.canonicalService.destroyLinkForCanonicalURL()
    this.canonicalService.setCanonicalURL();
    this.metaService.setOgTags("Election Manifesto 2024 "+TITLE_TIMELINE, DESCIPTION_BASE, 'https://cdn.newsfirst.lk/election/manifesto/election.jpeg', "/election-manifesto-2024");
  }

}
